import React, { Component } from 'react';

class GiftListSidebar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { isactiveItem, activeThemeColor, giftAvailable, isAgent } = this.props;
        return (
            <div className="gift-list-sidebar"> 
                {/* Sidebar content goes here */}
                {this.props.initialJson.giftList.items.map((item,index) => (
                    <div style={{
                        '--color-500': activeThemeColor || '#333',
                        display: ((((item.tabName == 'regalo-del-evento') && !giftAvailable) || ((item.tabName == 'crear-mesa') && isAgent)) ? 'none' : 'flex')
                      }}  className={`gift-list-sidebar-item ${item.id == isactiveItem ? 'active' : ''}`}  onClick={() => this.props.onItemClick(item.id)} key={item.id}>
                        <div className='gift-list-sidebar-item-image'>
                            <img src={item.image} alt="Gift Item" style={{ width: '24px', height: '24px' }} />
                        </div>
                        <div className='gift-list-sidebar-item-text'>
                            <span>{item.name}</span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default GiftListSidebar;